/**
 * To update the list of browser polyfills, please see polyfill.base.ts
 * Note: polyfill.base.ts is included via the tsconfig.base.json
 */

import 'polyfill.base';

/***************************************************************************************************
 * APPLICATION IMPORTS
 */
// CSS Vars (for IE)
import cssVars from 'css-vars-ponyfill';
import { loadDocumentBuilderPolyfills } from '@galaxy/document-builder/polyfills';

cssVars({
  watch: true,
  shadowDOM: true,
});

loadDocumentBuilderPolyfills('business-center-client');
